import { db } from '@/db/db';
import { RouteCourse, type Course } from './course';
import type { ProcessedRoute } from './model';
import { DEFAULT_ROUTE_ID, isBuiltinRouteId, loadAllBuiltinRoutes, loadBuiltinRoute } from './builtin/load';

export { DEFAULT_ROUTE_ID };

/** Built-in routes first (in their build order), then the rider's own imports, newest first. */
export async function listRoutes(): Promise<ProcessedRoute[]> {
  const own = (await db.routes.toArray()).filter((r) => !r.deleted);
  own.sort((a, b) => b.updatedAt - a.updatedAt);
  return [...(await loadAllBuiltinRoutes()), ...own];
}

export async function getRoute(id: string | null | undefined): Promise<ProcessedRoute | undefined> {
  if (!id) return loadBuiltinRoute(DEFAULT_ROUTE_ID);
  if (isBuiltinRouteId(id)) return loadBuiltinRoute(id);
  return db.routes.get(id);
}

/** Course for a route id; unknown or retired ids (e.g. the former demo loop) ride the default route. */
export async function getCourse(id: string | null | undefined): Promise<Course> {
  const r = (await getRoute(id)) ?? (await defaultRoute());
  return new RouteCourse(r);
}

export async function defaultCourse(): Promise<Course> {
  return new RouteCourse(await defaultRoute());
}

function defaultRoute(): Promise<ProcessedRoute> {
  return loadBuiltinRoute(DEFAULT_ROUTE_ID)!;
}

export async function deleteRoute(id: string): Promise<void> {
  if (isBuiltinRouteId(id)) return;
  const r = await db.routes.get(id);
  if (r) await db.routes.put({ ...r, deleted: true, updatedAt: Date.now() });
}
